import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserReadableError } from '../../../../app/api/errors/user-readable.error';

export type BinaryChoice = 'no' | 'yes';
export type HorizontalLayoutDirection = 'none' | 'start' | 'center' | 'end' | 'space-around' | 'space-between' | 'space-evenly';

@Component({
    selector: 'app-error-box',
    templateUrl: './error-box.component.html',
    styleUrls: ['./error-box.component.scss'],
    standalone: false,
})
export class ErrorBoxComponent implements OnInit, OnDestroy {
    @Input() error: UserReadableError | null = null;
    @Input() hasCloseButton: BinaryChoice = 'no';
    @Input() autoCloseMs = 0;
    @Input() horizontalDirection: HorizontalLayoutDirection = 'start';
    @Input() width = '100%';
    @Input() margin = '';

    private clearTimeout: ReturnType<typeof setTimeout> | null = null;

    public ngOnInit(): void {
        this.setAutoFadeOut();
    }

    public ngOnDestroy(): void {
        if (this.clearTimeout) {
            clearTimeout(this.clearTimeout);
        }
    }

    public clear(): void {
        this.error = null;
        if (this.clearTimeout) {
            clearTimeout(this.clearTimeout);
        }
    }

    private setAutoFadeOut(): void {
        if (!this.autoCloseMs) {
            return;
        }

        this.clearTimeout = setTimeout(() => {
            this.clear();
        }, this.autoCloseMs);
    }
}
